<template>
  <div
    v-if="product"
    class="component-product-dropdown d-flex align-items-center"
  >
    <div class="d-flex align-items-center gap-2">
      <span class="text-dark fs-14 text-semibold">
        {{ product.name }}
      </span>
      <small class="text-dark-40 fs-12"> ID {{ product.code }} </small>
      <small
        class="d-flex align-items-center product-badge"
        :class="`${product.status}-badge`"
      >
        <span>{{ product.status | formatStatus }}</span>
      </small>
      <bp-dropdown
        v-if="dropdown"
        :actions="actions"
        class="ml-2"
        @links="openLinks(product)"
        @deactivate="changeStatus"
      />
    </div>

    <div class="position-relative" v-if="tooltip">
      <slot name="tooltip" />
    </div>
  </div>
</template>

<script>
import ProductActionsMixin from "@/mixins/productActions.js";

export default {
  mixins: [ProductActionsMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
    dropdown: Boolean,
    tooltip: Boolean
  },
  computed: {
    actions() {
      const actions = [
        {
          text: "Links de divulgação",
          icon: "fa-light fa-link",
          event: "links"
        }
      ];
      if (this.product.status == "active") {
        actions.push({
          text: "Desativar produto",
          class: "text-negative-600",
          icon: "fa-light fa-power-off",
          confirmation: {
            text:
              "Tem certeza que deseja desativar este produto? Ao confirmar este produto não estará mais disponível para compra até que você o reative.",
            variant: "negative",
            buttonText: "Cancelar",
            secondaryButtonText: "Desativar",
            icon: "fa fa-hexagon-exclamation",
            secondary: true
          },
          event: "deactivate"
        });
      } else if (this.product.status == "inactive") {
        actions.push({
          text: "Ativar produto",
          class: "text-positive-600",
          icon: "fa-light fa-power-off",
          confirmation: {
            icon: "fa fa-hexagon-exclamation",
            variant: "alert",
            buttonText: "Entendido",
            text:
              "Entre em contato com o suporte para solicitar a ativação do produto."
          }
        });
      }
      return actions;
    }
  },
  methods: {
    changeStatus() {
      this.submitStatus(
        this.product,
        this.product.status === "inactive" ? "active" : "inactive"
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.component-product-dropdown {
  ::v-deep.btn.dropdown-toggle {
    min-height: 14px;
    padding: 0;
  }
  .text-left {
    color: #77788edd;
  }
  .product-badge {
    height: fit-content;
    padding: 0 8px;
  }
}
</style>
